import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-team-summary',
    templateUrl: './team-summary.component.html',
    styleUrls: ['./team-summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TeamSummaryComponent {
  @Input() name = '';
  @Input() amount: number | string = 0;
  @Input() membersCount: number | null = null;
  @Input() canEdit = false;
  @Output() edit = new EventEmitter<void>();
}
